module.exports = __webpack_public_path__ + "img/cuff buttons quantity.3ae83e85.png";